const testIds = {
  cancellationPolicy: 'cancellationPolicy',
  payment: 'payment',
  prepay: 'prepay',
  precautions: 'precautions',
  noShowPolicy: 'noShowPolicy',
  listitem_title: 'title',
  listitem_description_desktop: 'description_desktop',
  listitem_description_mobile: 'description_mobile',
};

export default testIds;
